import React from "react";
import VehicleForm from "components/forms/OrderDeviceForm.jsx";
import { Helmet } from "react-helmet";
import useMediaQuery from "utils/CustonHooks/UseDeviceResponsiveHook";

const OrderDevice = (props) => {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const iframeHeight = isDesktop ? "700px" : "1030px";

  return (
    <div>
      <Helmet>
        <title>Order a Device - TecHGV</title>
      </Helmet>
      <section className="OrderDevice" id="hero">
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-12 hero-text-image"
              style={{ padding: "0px 0px 30px 0px" }}
            >
              <div style={{ paddingLeft: "17px" }}>
                <h1
                  data-aos="fade-right"
                  style={{ padding: "30px 0px 00px 0px" }}
                >
                  Order a Device
                </h1>
                <p style={{ textAlign: "start", paddingBottom: "20px" }}>
                 Each Telematic requires a £100 security deposit, which is fully refundable.
                </p>
              </div>
              {/* <VehicleForm className={"w-50"} /> */}
              <iframe
                src="https://forms.techgv.co.uk/order-a-device/"
                width="100%"
                height={iframeHeight}
                frameBorder="0"
                allowFullScreen
                title="Order Device Form"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OrderDevice;
